"use strict";
exports.__esModule = true;
exports.DeferredResult = void 0;
var getSetOfIds = function (ids) {
    if (ids instanceof Set || Array.isArray(ids)) {
        return new Set(ids);
    }
    return new Set([ids]);
};
/**
 * Represents a set of node IDs that a store needs to ask its parent about in order to finish
 * resolving. The ultimate source of these results is the `useDeferredNode()` hook, which allows
 * attributes to ask for values from other nodes before resolving.
 */
var DeferredResult = /** @class */ (function () {
    function DeferredResult(requestedNodeIds, callback) {
        this.requestedNodeIds = getSetOfIds(requestedNodeIds);
        this.callback = callback;
    }
    return DeferredResult;
}());
exports.DeferredResult = DeferredResult;
